<template>
    <!--useCase2-->
    <!--tab 里的子表-->
    <div id="tableComps">

        <div class="tableComps_header">
            <slot name="topFunction"></slot>
            <a-dropdown v-if="tableFuncionSearch">
                <a class="ant-dropdown-link" href="#">
                    <img src="../../../assets/img/ss-more.png" width="15" height="15">
                </a>
                <a-menu slot="overlay">
                    <a-menu-item style="font-size: 12px" @click="AdvanceSearch">
                        <a-icon type="zoom-in" /> {{ $t('pubGicSet.AdvanceSearch') }}
                    </a-menu-item>
                    <a-menu-item style="font-size: 12px" @click="searchSort">
                        <a-icon type="ordered-list" /> {{ $t('pubGicSet.AdvanceSort') }}
                    </a-menu-item>
                    <a-menu-item style="font-size: 12px" @click="columnSetting">
                        <a-icon type="table" /> Column Setting
                    </a-menu-item>
                    <a-sub-menu>
                        <span slot="title"><a-icon type="lock" /> {{ $t('pubGicSet.FreezeCol') }}:</span>
                        <a-menu-item @click="handleChange(0)">{{ $t('pubGicSet.Clear') }}</a-menu-item>
                        <a-menu-item @click="handleChange(1)">1</a-menu-item>
                        <a-menu-item @click="handleChange(2)">2</a-menu-item>
                        <a-menu-item @click="handleChange(3)">3</a-menu-item>
                        <a-menu-item @click="handleChange(4)">4</a-menu-item>
                        <a-menu-item @click="handleChange(5)">5</a-menu-item>
                        <a-menu-item @click="handleChange(6)">6</a-menu-item>
                    </a-sub-menu>
                </a-menu>
            </a-dropdown>
        </div>
        <!--子表动态表格-->
        <vxe-table
                stripe
                highlight-hover-row
                border
                resizable
                show-overflow
                size="mini"
                class="mytable-style sortable-row-demo"
                :data.sync="dataTest"
                @checkbox-all="selectAllEvent"
                @checkbox-change="checkboxChange"
                :cell-class-name="cellClassName"
                @cell-click="cellClickEvent"
                @cell-dblclick="dbcellClickEvent"
                :max-height="MaxHeight"
                :keyboard-config="{ isArrow: true }"
                @header-cell-dblclick="headerCellDbclick"
                ref="subTable"
                :footer-method="footerMethod"
        >
            <!--:loading="loading"-->
            <!--:show-footer="statisticsStatus"-->
            <!--:footer-cell-class-name="footerCellClassName"-->
            <!--:footer-method="footerMethod"-->
            <!--@header-cell-dblclick="headerCellDbclick"-->
            <template v-slot:empty>
                <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
            </template>
            <template>
                <vxe-table-column type="checkbox" width="35" :fixed="fixedNum > 0 ? 'left' : ''" ></vxe-table-column>
                <template  v-for="(item, index) in cols">
                    <vxe-table-column :fixed="index < fixedNum ? 'left' : ''">
                        <!--表头页数改咯很多次-->
                        <template v-slot:header>
                            <a-tooltip placement="bottomLeft" v-if="statisticsStatus">
                                <span v-if="item.statisticsValue4OnePage == null || item.statisticsValue == null"></span>
                                <span v-else>
                                        <a-tooltip>
                                          <template slot="title">
                                            {{item.statistics == 'Count' ? 'Count': 'Sum'}}
                                          </template>
                                          <span class="fontWeight6" :style="{color: item.statistics == 'Count' ? 'green' : 'blue'}" >{{item.statistics == 'Count' ? 'C:': 'S:'}}</span>
                                          <span class="fontWeight6" :style="{color: item.statistics == 'Count' ? 'green' : 'blue'}">{{item.statisticsValue}}</span>
                                        </a-tooltip>
                                    </span>

                            </a-tooltip>
                        </template>
                        <vxe-table-column show-header-overflow show-overflow :fixed="index < fixedNum ? 'left' : ''" :width="item.proWidth == null ? '350' : item.proWidth">
                            <template v-slot:header="{ column }">
                                <a-row v-show="headerCellDbclickVis" class="sbxs">
                                    <!--功能-->
                                    <a-row>
                                        <a-tooltip placement="topLeft">
                                            <template slot="title">
                                                <span v-cloak> {{item.description == null ? item.title : item.description}}</span>
                                            </template>
                                            <span v-cloak @click="headerCellDbclick" style="font-weight: 600"> {{ item.title }}</span>
                                        </a-tooltip>
                                        <a-icon type="caret-up" class="sortBtnClass" @click="locaSort(1, item)" v-if="upDownType"/>
                                        <a-icon type="caret-down" class="sortBtnClass" @click="locaSort(-1, item)" v-else/>
                                    </a-row>
                                    <a-row style="display: flex;align-items: center;padding-bottom: 4px;" :style="{width:item.proWidth == null ? '320px' : item.proWidth - 30 +'px'}" >
                                        <a-date-picker showTime v-if="item.type == 'Datetime' || item.type == 'Date'" placeholder="Basic usage" style="width: 100%;" size="small" :defaultValue="item.serVal != undefined ? moment(item.serVal, 'YYYY-MM-DD') : null" format="YYYY-MM-DD" @change="dateTimeEvent" @openChange="openDateTimeEvent(item)"/>
                                        <a-select mode="multiple" v-else-if="item.type == 'DROP'" style="width: 100%;" size="small" @dropdownVisibleChange="tableTitleSelectData(item)" @change="titleSlecChange" :defaultValue="item.serVal">
                                            <a-select-option v-for="i in  titleSelectData" :value="i.key">{{i.value}}</a-select-option>
                                        </a-select>
                                        <a-input
                                                v-else="item.type == 'String'"
                                                type="text"
                                                placeholder="Search"
                                                style="width: 100%;border-right: none;height: 25px"
                                                v-model="item.serVal"
                                                @keyup.enter="searchTitleCont"
                                                size="small"
                                        />
                                        <a-icon type="search" @click="searchTitleCont" style="font-size: 14px;" class="ml4"/>
                                    </a-row>
                                </a-row>
                                <a-tooltip placement="topLeft" v-show="!headerCellDbclickVis">
                                    <template slot="title">
                                        <span v-cloak>{{item.description == null ? item.title : item.description}}</span>
                                    </template>
                                    <span v-cloak @click="headerCellDbclick" style="font-weight: 600" class="sbxs"> {{ item.title }}</span>
                                </a-tooltip>
                            </template>
                            <template v-slot="{ row }">
                                <img
                                        v-if="row[item.label].config.fieldType == 'Image'"
                                        :src="row[item.label].value"
                                        width="80"
                                        height="30"/>
                                <div v-else>
                                    <a-tooltip placement="bottomLeft">
                                        <template slot="title">
                                            <span v-cloak>{{row[item.label].value}}</span>
                                        </template>
                                        <span
                                                v-if="row[item.label].config.fieldType == 'POPUP'"
                                                style="cursor:pointer;text-decoration:underline;"
                                                @click="skuDetailCao(row[item.label])">{{ row[item.label].value }}</span>
                                        <span v-else v-cloak>{{ row[item.label].value | textValFilter(item)}}</span>
                                    </a-tooltip>
                                </div>
                            </template>
                        </vxe-table-column>
                    </vxe-table-column>
                </template>
            </template>
        </vxe-table>

        <!--排序-->
        <a-modal :title="$t('pubGicSet.Sort')" v-model="searchSortVis" width="50%">
            <template slot="footer">
                <a-button type="primary" @click="getUpdateEvent">{{ $t('pubGicSet.Search') }}</a-button>
            </template>
            <div  style="height: 55vh;">
                <vxe-table
                        border
                        height="auto"
                        class="sortable-row-demo vxe-table-antd"
                        row-key
                        size="mini"
                        ref="subSortTable"
                        :data.sync="editTableData"
                        :edit-config="{ key: 'detaileUid', trigger: 'click', mode: 'row' }">
                    <template v-slot:empty>
                        <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
                    </template>
                    <vxe-table-column type="checkbox" width="60"></vxe-table-column>
                    <!--<vxe-table-column type="index" label="sort Seq" width="100"></vxe-table-column>-->
                    <vxe-table-column
                            show-header-overflow="ellipsis"
                            show-overflow="ellipsis"
                            field="fieldName"
                            :title="$t('pubGicSet.FieldName')"
                    ></vxe-table-column>
                    <vxe-table-column
                            show-header-overflow="ellipsis"
                            show-overflow="ellipsis"
                            field="orderBy"
                            :title="$t('pubGicSet.OrderBy')"
                            width="140"
                            :edit-render="{ type: 'visible' }">
                        <template v-slot:edit="{ row, rowIndex }">
                            <a-switch v-model="row.orderBy" checkedChildren="asc" unCheckedChildren="desc" size="small"></a-switch>
                        </template>
                    </vxe-table-column>
                </vxe-table>
            </div>
        </a-modal>
        <!--添加Advance search temalate name-->
        <a-modal :title="DrawerTitle" v-model="AdchNameVis">
            <template slot="footer">
                <a-button size="small" type="primary" @click="SaveTamplateName">{{ $t('publicLang.Save') }}</a-button>
            </template>
            <a-form :form="AdchNameFrom">
                <a-form-item :label="$t('pubGicSet.Name')" v-bind="formItemLayout">
                    <a-input
                            v-decorator="[
                          'template',
                          { rules: [{ required: true, message: $t('publicLang.Required') }] }
                        ]"
                            :placeholder="$t('pubGicSet.PleaseName')"/>
                </a-form-item>
            </a-form>
        </a-modal>

        <!--Advance search -->
        <a-modal
                :title="DrawerTitle"
                v-model="AdvanceSearchVis"
                width="80%"
                @cancel="cancelAdvanceSearch">
            <a-row type="flex" justify="start" class="mt">
                <a-col class="mr4"><span>{{ $t('pubGicSet.SearchTemplate') }}: </span></a-col>
                <a-col class="mr4">
                    <a-select
                            size="small"
                            style="width: 240px"
                            :placeholder="$t('pubGicSet.AdvanceSearcheTemplate')"
                            v-model="targetAdvanceTml"
                            @change="changeTamplateAdvace">
                        <a-select-option :value="item" v-for="item in AdvanceTemplate">{{ item }}</a-select-option>
                    </a-select>
                </a-col>
                <a-col class="mr4">
                    <a-tooltip placement="topLeft">
                        <template slot="title">
                            <span>{{ $t('manual.New') }}</span>
                        </template>
                        <img class="sbxs" src="../../../assets/img/ss-add.png" @click="showAddTemplatName" width="22" height="22">
                    </a-tooltip>
                </a-col>
                <a-col class="mr4">
                    <a-popconfirm
                            :title="$t('pubGicSet.AreyoudeleTask')"
                            :okText="$t('pubGicSet.Yes')"
                            :cancelText="$t('pubGicSet.No')"
                            @confirm="deleteTemplatName">
                        <a-tooltip placement="topLeft">
                            <template slot="title">
                                <span>{{ $t('pubGicSet.delete') }}</span>
                            </template>
                            <img class="sbxs" src="../../../assets/img/ss-delete.png" width="22" height="22">
                        </a-tooltip>
                    </a-popconfirm>
                </a-col>
                <a-col class="mr4">
                    <a-tooltip placement="topLeft">
                        <template slot="title">
                            <span>{{ $t('publicLang.Save') }}</span>
                        </template>
                        <img @click="saveTemplateVers" class="sbxs ml4" src="../../../assets/img/ss-save.png" width="20" height="20">
                    </a-tooltip>
                </a-col>
            </a-row>
            <a-row>
                <and-or :options="options" :isFirst="isFirst" ref="andOr"></and-or>
            </a-row>
            <template slot="footer">
                <a-button type="primary" @click="getQueryFilter" size="small">{{ $t('pubGicSet.Search') }}</a-button>
            </template>
        </a-modal>
        <!--表格配置cell 点击去看详情-->
        <popup-single ref="popupSingleRef" :QueryUpdatas="QueryUpdatas"></popup-single>

        <!--column setting-->
        <a-modal v-model="columnSettingVis" title="Column Setting">
            <template slot="footer">
                <a-button size="small" type="danger" @click="cancelColumnSetting">Cancel</a-button>
                <a-button size="small" type="primary" @click="saveColumnSetting">Save</a-button>
            </template>
            <div style="height: 55vh;">
                <vxe-table
                        border
                        height="auto"
                        class="sortable-row-demo vxe-table-antd"
                        row-key
                        size="mini"
                        ref="subcoluSetSortTable"
                        :data.sync="columnSettingData"
                        :edit-config="{ key: 'uid', trigger: 'click', mode: 'row' }"
                >
                    <template v-slot:empty>
                        <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
                    </template>
                    <vxe-table-column
                            show-header-overflow="ellipsis"
                            show-overflow="ellipsis"
                            field="fieldName"
                            title="Column Name"
                    ></vxe-table-column>
                    <vxe-table-column
                            show-header-overflow="ellipsis"
                            show-overflow="ellipsis"
                            field="displayable"
                            title="Displayable"
                            width="140"
                            :edit-render="{ type: 'visible' }"
                    >
                        <template v-slot:edit="{ row, rowIndex }">
                            <a-switch v-model="row.displayable" size="small"></a-switch>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column
                            show-header-overflow="ellipsis"
                            show-overflow="ellipsis"
                            field="searchable"
                            title="Searchable"
                            width="140"
                            :edit-render="{ type: 'visible' }"
                    >
                        <template v-slot:edit="{ row, rowIndex }">
                            <a-switch v-model="row.searchable" size="small"></a-switch>
                        </template>
                    </vxe-table-column>
                </vxe-table>
            </div>
        </a-modal>
    </div>
</template>
<script>
    import ajax from "../../../api/ajax";
    import api from "../../../api/url";
    import Sortable from "sortablejs";
    import andOr from "../queryBuilder/components/AndOR.vue";
    import { mapState } from "vuex";
    import popupSingle from "../../masterData/components/popupSingle.vue";
    import moment from "moment";
    //import virtualList from 'vue-virtual-scroll-list'
    export default {
        components: {
            andOr,
            popupSingle
        },
        props: {
            MaxHeight: {
                type: Number,
                default: function() {
                    return 200;
                }
            },
//            是否需要功能
            tableFuncionSearch: {
                type: Boolean,
                default: function() {
                    return true;
                }
            },
            // 是否需要表头搜索
            functionSeting: {
                type: Boolean,
                default: function() {
                    return true;
                }
            },
            // 固定列数
            fixedNum: {
                type: Number,
                default: function() {
                    return 0;
                }
            },
            // 表头
            cols: {
                type: Array,
                default: function() {
                    return [];
                }
            },
            // 表格数据
            tableData: {
                type: Array,
                default: function() {
                    return [];
                }
            },
            // 表格uid
            setGmcuid: {
                type: Number,
                default: function() {
                    return null;
                }
            },
//            report 所需参数 这页面重新做不知道着干嘛的
            userReport:{
                type: Object,
                default: function() {
                    return {};
                }
            }
        },
        data() {
            return {
                columnSettingVis: false,
                columnSettingData: [],

                upDownType: false,
                titleSelectData: [], // title status 下拉数据
                sliceStartTable: 0,
                sliceEndTable: 50,
                statisticsStatus: true,
                clientHeight: "",
                DrawerTitle: "", // Advance  Search title
                oldQueryFormStatus: {}, // 保存以前query filter
                options: {
                    // query filter 下拉
                    condition: [],
                    fieldNameSel: [],
                    status: []
                }, // advan 下拉数据
                visiblePopover: false, // 是显示最后set popover
                isFirst: true,
                AdvanceSearchVis: false,
                fixNum: "",
                searchSortVis: false,
                editTableData: [],
                selectRow: null,
                AdvanceTemplate: "",
                targetAdvanceTml: "",
                AdchNameVis: false,
                AdchNameFrom: this.$form.createForm(this),
                formItemLayout: {
                    labelCol: {
                        xs: { span: 24 },
                        sm: { span: 8 }
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 16 }
                    }
                },
                QueryUpdatas: {},
                headerCellDbclickVis: false,
                sortKey: "",
                sortType: "",
                oldTable: [],
                targetSelectItem: '',
                targetDateTimeItem: {},
                geExtHeaderUid: '', // columnSetting uid
            };
        },
        created() {
            this.fixNum = this.fixedNum
        },
        destroyed() {
            if (this.sortable) {
                this.sortable.destroy();
            }
        },
        computed: {
            ...mapState(["lang"]),
//            表格排序
            dataTest() {
                let a = false
                for(let i in this.cols){
                    if(this.cols[i].statisticsValue != null ){
                        a = true
                    }
                }
                if(a){
                    this.statisticsStatus = true
                }else{
                    this.statisticsStatus = false
                }
                let that = this;
                let tableData = this.tableData;
                let sortKey = this.sortKey;
                if (sortKey) {
                    return tableData.sort(that.compare(sortKey));
                }else{
                    return tableData;
                }
            }
        },
        filters: {
//            过滤日期
            textValFilter: function (val,params) {
                if(val == null){
                    return ''
                }else{
                    if(params.type == "Datetime"){
                        if(params.dataFormat != null){
                            let t = moment(val).format(params.dataFormat);
                            return t
                        }else{
                            return val
                        }
                    }else if(params.type == "Decimal"){
                        if(params.dataFormat != null){
                            let t = this.pub_decimaltoFixed(val, params.dataFormat)
                            return t
                        }else{
                            return val
                        }
                    }else{
                        return val
                    }
                }
            },
        },
        methods: {
            getSlectRow(row){
                this.selectRow = row
            },
            columnSetting(){
                ajax.get(api.GENERICEXTGENERICCOLUMN,{gmcUid: this.setGmcuid}).then(res=>{
                    if(res.code == 200){
                        this.geExtHeaderUid = res.data.uid
                        ajax.get(api.GENERICEXTGENERICPAGEPROPERTY,{geExtHeaderUid: res.data.uid}).then(res=>{
                            this.columnSettingData = res.data.geExtDetailDtos
                            if(this.columnSettingData.length > 0){
                                for(let i in this.columnSettingData){
                                    this.columnSettingData[i].displayable = this.columnSettingData[i].displayable == 1 ? true : false
                                    this.columnSettingData[i].searchable = this.columnSettingData[i].searchable == 1 ? true : false
                                }
                            }
                            this.columnSettingVis = true
                            this.$nextTick(() => {
                                let sortTable= this.$refs.subcoluSetSortTable
                                let sortable = Sortable.create(sortTable.$el.querySelector('.body--wrapper>.vxe-table--body tbody'), {
                                    onEnd: ({ newIndex, oldIndex }) => {
                                        let currRow = this.columnSettingData.splice(oldIndex, 1)[0];
                                        this.columnSettingData.splice(newIndex, 0, currRow);
                                    }
                                });
                            });
                        })
                    }
                })
            },
            //      cancel column Setting
            cancelColumnSetting(){
                ajax.get(api.GNERICEXTGENERICCANCEL,{geExtHeaderUid: this.geExtHeaderUid}).then(res=>{
                    if(res.code == 200){
                        this.$message.success(res.msg)
                        this.columnSettingVis = false
                        this.$emit("sortTableData", 'columnSetting');
                    }
                })
            },
//      保存columnSetting
            saveColumnSetting(){
                let data = JSON.parse(JSON.stringify(this.columnSettingData))
                for(let i in data){
                    data[i].displayable = data[i].displayable  ? '1' : '0'
                    data[i].searchable = data[i].searchable ? '1' : '0'
                }
                ajax.post(api.GENERICEXTGENERICPAGEPROPERTY,{geExtDetailDtos: data}).then(res=>{
                    if(res.code == 200){
                        this.$message.success(res.msg)
                        this.$emit("sortTableData", 'columnSetting');
                        this.columnSettingVis = false
                    }
                })
            },

//      保留小学
            pub_decimaltoFixed(params,num) {
                let newpar = parseFloat(params);
                let reg = /^[0-9]+.?[0-9]*$/;
                if(reg.test(newpar)){
                    let newNum = newpar.toFixed(num);
                    return newNum
                }else{
                    return params
                }
            },
//            刷新table
            newData(){
                this.$refs.subTable.reloadData(this.tableData)
                this.$refs.subTable.reloadColumn(columns)(this.tableData)
                this.$refs.subTable.refreshColumn()
            },
//           表头日期下拉事件
            dateTimeEvent(val){
                for(let i in this.cols){
                    if(this.cols[i].label == this.targetDateTimeItem.label){
                        if(val == null){
                            this.cols[i].serVal = ''
                        }else{
                            this.cols[i].serVal = val._d
                        }
                    }
                }
            },
            openDateTimeEvent(item){
                this.targetDateTimeItem = item
            },
            moment,
            //           表头select下拉事件
            titleSlecChange(val){
                for(let i in this.cols){
                    if(this.cols[i].label == this.targetSelectItem.label){
                        this.cols[i].serVal = val
                    }
                }
            },
            //           表头select下拉数据
            tableTitleSelectData(item){
                let ppArr = []
                let params = {
                    language: this.lang,
                    gmcUid: item.pattern.gmcUid,
                    params: ppArr
                };
                ajax.post(api.GETSELECTARRAY, params).then(res => {
                    this.targetSelectItem = item
                    this.titleSelectData = res.data
                });
            },
//      底部合集样式 start 废弃
            footerCellClassName ({ $rowIndex, column, columnIndex }) {
                return 'footerBackColor'
            },
            footerMethod({ columns, data }) {
                let that = this;
                let a = false
                for(let i in this.cols){
                    if(this.cols[i].statisticsValue != null ){
                        a = true
                    }
                }
                if(a){
                    this.statisticsStatus = true
                }else{
                    this.statisticsStatus = false
                }
                return [
                    columns.map((column, columnIndex) => {
                        if(columnIndex == 0){
                            return ''
                        }else{
                            let arr = []
                            let val = 0
                            let tt = ''
                            let dataUid = this.cols[columnIndex-1].label
                            for(let i in data){
                                arr.push(data[i][dataUid].value)
                            }
                            if(this.cols[columnIndex-1].statistics == 'SUM'){
                                for (var i=arr.length-1; i>=0; i--) {
                                    val += arr[i] - 0;
                                }
                                tt = val + '/'+ this.cols[columnIndex-1].statisticsValue
                            } else if (this.cols[columnIndex-1].statistics == 'Count'){
                                val =  Array.from(new Set(arr)).length
                                tt =val + '/'+ this.cols[columnIndex-1].statisticsValue
                            } else{
                                tt = ''
                            }
                            return tt
                        }
                    })
                ];
            },
            //      底部合集样式 end
//      本地排序
            compare(propertyName) {
                return (object1, object2) => {
                    let a =
                        object1[propertyName].value == null
                            ? "9"
                            : object1[propertyName].value;
                    let b =
                        object2[propertyName].value == null
                            ? "9"
                            : object2[propertyName].value;
                    if (a < b) {
                        return this.sortType * 1;
                    } else if (a > b) {
                        return this.sortType * -1;
                    }
                    return 0;
                };
            },
            //            本地排序
            locaSort(type, item) {
                this.upDownType = !this.upDownType
                this.sortKey = item.label;
                this.sortType = type;
            },
//      头部双击
            headerCellDbclick() {
                this.$refs.subTable.refreshColumn()
                this.headerCellDbclickVis = !this.headerCellDbclickVis;
            },
            //            显示新增加ansearch tamplate nam
            showAddTemplatName() {
                this.AdchNameVis = true;
            },
//       保存advanSearch 模板
            saveTemplateVers(){
                if(this.targetAdvanceTml != ''){
                    let params = this.$refs.andOr.queryFormStatus();
                    params.template = this.targetAdvanceTml
                    params.gmcUid = this.setGmcuid;

                    if(this.userReport.ugcUid != undefined){
                        params.ugcUid = this.userReport.ugcUid
                        ajax.post(api.GENERICUDRTEMPLATEREAL, params).then(res=>{
                            if (res.code == 200) {
                                this.$message.success(this.$t('pubGicSet.SaveSuccess'))
                            }
                        })
                    }else{
                        ajax.post(api.QUERYFILTER, params).then(res => {
                            if (res.code == 200) {
                                this.$message.success(this.$t('pubGicSet.SaveSuccess'))
                            }
                        })
                    }
                }else{
                    this.$message.warning(this.$t('pubGicSet.PleaseTamplateNameFirst'));
                }
            },
//      弹窗添加template name
            SaveTamplateName() {
                this.AdchNameFrom.validateFields((error, values) => {
                    if (!error) {
                        let params = this.$refs.andOr.queryFormStatus();
                        params.template = values.template;
                        params.gmcUid = this.setGmcuid;
                        if(this.userReport.ugcUid != undefined){
                            params.ugcUid = this.userReport.ugcUid
                            ajax.post(api.GENERICUDRTEMPLATEREAL, params).then(res=>{
                                if (res.code == 200) {
                                    this.init();
                                    this.AdchNameVis = false;
                                    this.AdchNameFrom.resetFields();
                                }
                            })
                        }else{
                            ajax.post(api.QUERYFILTER, params).then(res => {
                                if (res.code == 200) {
                                    this.init();
                                    this.AdchNameVis = false;
                                    this.AdchNameFrom.resetFields();
                                }
                            });
                        }
                    }
                });
            },
            //            删除tamplate Name
            deleteTemplatName() {
                let params = {
                    gmcUid: this.setGmcuid,
                    templateName: this.targetAdvanceTml
                };
                ajax.post(api.DELETETEMPLATE, params).then(res => {
                    if (res.code == 200) {
                        this.init();
                        this.AdvanceSearch();
                    }
                });
            },
//            选择模板 查adva search 数据
            changeTamplateAdvace(val) {
                let params = {
                    gmcUid: this.setGmcuid,
                    template: val
                };
                if(this.userReport.ugcUid != undefined){
                    params.ugcUid = this.userReport.ugcUid
                }
                ajax.get(api.QUERYFILTER, params).then(res => {
                    let queryObj = res.data;
                    this.$refs.andOr.fillFormStatus(queryObj);
                });
            },
//            初始数据
            init() {
                let tmlParams = {
                    gmcUid: this.setGmcuid,
                }
                if(this.userReport.ugcUid != undefined){
                    tmlParams.ugcUid = this.userReport.ugcUid
                }
                ajax.get(api.ADVANCETEMPLATE, tmlParams).then(res => {
                    this.AdvanceTemplate = res.data;
                    this.targetAdvanceTml = this.AdvanceTemplate[0];
                });
            },
//            点击advansearch 出现
            AdvanceSearch(type) {
                let menuActive = sessionStorage.getItem("menuActive");
                let menuArr = JSON.parse(sessionStorage.getItem("menu"));
                if (menuArr == null) {
                    this.DrawerTitle = "Home";
                } else {
                    menuArr.forEach((v, i) => {
                        if (v.key == menuActive) {
                            this.DrawerTitle = v.funcName;
                        }
                    });
                }
//      获取模板
                let tmlParams = {
                    gmcUid: this.setGmcuid,
                }
                if(this.$route.path == "/userReport"){
                    tmlParams.ugcUid = this.userReport.ugcUid == undefined ? 0 : this.userReport.ugcUid
                }
                ajax.get(api.ADVANCETEMPLATE,tmlParams).then(res => {
                    this.AdvanceTemplate = res.data;
                    this.targetAdvanceTml = this.AdvanceTemplate[0];
                });
                let params = {
                    gmcUid: this.setGmcuid
                };
                ajax.get(api.GETSQLDROPDATA).then(res => {
                    this.options.condition = res.data.condition;
                });

                if(this.$route.path == "/userReport"){
                    let paramsUgc = {
                        gmcUid: this.setGmcuid,
                        ugcUid: this.userReport.ugcUid == undefined ? 0 : this.userReport.ugcUid
                    }
                    ajax.get(api.GENERICUDRDROPDOWNFIELNAME,paramsUgc).then(res=>{
                        this.options.fieldNameSel = res.data;
                    })
                }else{
                    ajax.post(api.GETFIELDNAMEDROPDATA, params).then(res => {
                        this.options.fieldNameSel = res.data;
                    });
                }

                ajax.get(api.GEBERICMODULESTATUS, { gmcUid: this.setGmcuid }).then(res => {
                    this.options.status = res.data;
                });
                this.AdvanceSearchVis = true;

                if(this.$route.path == "/userReport"){
                    let queryParams = {
                        gmcUid: this.setGmcuid,
                        ugcUid: this.userReport.ugcUid == undefined ? 0 : this.userReport.ugcUid
                    };
                    ajax.get(api.GENERICYDRTMLDEFAULT,queryParams).then(res=>{
                        if(res.code == 200){
                            let queryObj = res.data;
                            if(queryObj.rules == null){
                                queryObj = undefined
                            }else{
                                queryObj = res.data.rules[0]
                            }
                            this.$nextTick(()=>{
                                this.$refs.andOr.fillFormStatus(queryObj);
                            })
                        }else{
                            this.$message.error(res.msg);
                            this.AdvanceSearchVis = false
                            return
                        }

                    })
                }else{
                    let queryParams = {
                        gmcUid: this.setGmcuid
                    };
                    ajax.get(api.QUERYFILTER, queryParams).then(res => {
                        let queryObj = res.data;
                        this.$nextTick(()=>{
                            this.$refs.andOr.fillFormStatus(queryObj);
                        })
                    });
                }
                this.visiblePopover = false;
            },
            //            提交
            getQueryFilter(){
                let params = {
                    query: this.$refs.andOr.queryFormStatus(),
                    tml: this.targetAdvanceTml
                };
                this.$emit("renderQueryVal", params);
                this.AdvanceSearchVis = false;
            },
            //            关闭也需要保存queryFilter data
            cancelAdvanceSearch() {
                this.oldQueryFormStatus = this.$refs.andOr.queryFormStatus();
            },
//            固定
            handleChange(value) {
                this.fixNum = value;
                this.$emit("rederSub", parseInt(this.fixNum));
            },
            //            title Search
            searchTitleCont() {
                this.$emit("renderSearchVal", this.cols);
            },
            //            推拽
            rowDrop() {
                this.$nextTick(() => {
                    let sortTable = this.$refs.subSortTable
                    let sortable = Sortable.create(sortTable.$el.querySelector('.body--wrapper>.vxe-table--body tbody'), {
                        onEnd: ({ newIndex, oldIndex }) => {
                            let currRow = this.editTableData.splice(oldIndex, 1)[0];
                            this.editTableData.splice(newIndex, 0, currRow);
                        }
                    });
                });
            },
            //            双击当前行变色
            cellClassName({ row }) {
                if (row === this.selectRow) {
                    return "col-orange";
                }
            },
            //            单击当前行变色
            cellClickEvent({ row }) {
                this.$emit("selectRowData", row);
                this.selectRow = row;
            },
//            双击
            dbcellClickEvent({ row }){
                this.$emit("dblselectRowData", row);
            },
            //            checkbox选择
            checkboxChange(value) {
                this.$emit("checkBoxSelectData", value.selection);
            },
//            全选
            selectAllEvent(value) {
                this.$emit("checkBoxSelectData", value.selection);
            },
            //            表头最后一个sort
            searchSort() {
                //                提示拖动
                this.$message.success(this.$t('publicLang.DraglistSort'));
                let gmcUid = this.setGmcuid;
                this.searchSortVis = true;
                this.visiblePopover = false;
                ajax.get(api.SEARCHSORT, { gmcUid: gmcUid }).then(res => {
                    this.editTableData = res.data;
                    let checkboArr = [];
                    this.editTableData.forEach((v, i) => {
                        v.orderBy = v.orderBy == 0 ? false : true;
                        if (v.isSort == "1") {
                            checkboArr.push(this.editTableData[i]);
                        }
                        this.$refs.subSortTable.setCheckboxRow(checkboArr, true);
                    });
                    this.rowDrop();
                });
            },
//            sort 排序
            getUpdateEvent() {
                let updateRecords = this.$refs.subSortTable.getCheckboxRecords();
                for (let ii in updateRecords) {
                    updateRecords[ii].isSort = "1";
                }
                this.$emit("renderSortVal", updateRecords);
                this.searchSortVis = false;
            },
//            点击cell 去详情
            skuDetailCao(row) {
                let params = {
                    gmcUid: row.config.fieldPattern.gmcUid,
                    language: this.lang,
                    pop: {
                        schemaUid: row.config.schemaUid,
                        value: row.value
                    }
                };
                this.$nextTick(() => {
                    this.$refs.popupSingleRef.openPopup();
                });
                ajax.post(api.POPUP, params).then(res => {
                    this.QueryUpdatas = res;
                });
            }
        }
    };
</script>
<style>
    #tableComps .tableComps_header{
        display: flex;
        justify-content: space-between;
        height: 35px;
        align-items: center;
    }
    .setTableIconClass {
        padding: 5px 0;
        cursor: pointer;
    }
    .setTableIconClass:hover {
        color: #094bff;
    }
    .sortBtnClass {
        cursor: pointer;
        font-size: 12px;
    }
    .sortBtnClass:active {
        color: #409eff;
    }
    .mytable-style .vxe-body--column.col-orange {
        background-color: #73459d;
        color: #fff;
    }

    .vxe-table .vxe-table--fixed-right-wrapper {
        z-index: 99;
    }

    .sortable-row-demo .drag-btn {
        cursor: move;
        font-size: 12px;
    }
    .sortable-row-demo .vxe-body--row.sortable-ghost,
    .sortable-row-demo .vxe-body--row.sortable-chosen {
        background-color: #dfecfb;
    }
    .vxe-table.size--small .vxe-body--column, .vxe-table.size--small .vxe-footer--column, .vxe-table.size--small .vxe-header--column{
        padding: 0 !important;
    }
    .vxe-table .vxe-body--column, .vxe-table .vxe-footer--column, .vxe-table .vxe-header--column{
        line-height: 20px !important;
    }
</style>
